import {
  ButtonType,
  ButtonWidget,
  InteractionState
} from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { imgPath } from '../../../common/utilities/ImgUrl';
import { SpaceHeaderStyles } from './SpaceHeaderStyles';

const ICON_PATH = imgPath('data_prep_info.svg');
const ACTIVE_ICON_PATH = imgPath('data_prep_info_active.svg');

const getDetailButtonContent = (state: InteractionState): JSX.Element => {
  const showActiveIcon = state.hover || state.active || state.focus;
  return (
    <div className={SpaceHeaderStyles.InfoDetailContent} >
      <img
        className={SpaceHeaderStyles.InfoDetailImage}
        src={showActiveIcon ? ACTIVE_ICON_PATH : ICON_PATH}
        alt=""
      />
    </div>
  );
};

export interface DetailButtonProps {
  readonly testId: string;
  readonly onClick: () => void;
}

export function DetailButton(props: DetailButtonProps) {
  return (
    <ButtonWidget
      buttonType={ButtonType.IconOutline}
      getContent={getDetailButtonContent}
      title={Messages.details()}
      testId={`${props.testId}-detail-button`}
      handleClick={props.onClick}
    />
  );
}
